var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.147 10.38c2.041 0 3.696-1.622 3.696-3.622 0-2-1.655-3.623-3.696-3.623-2.041 0-3.696 1.622-3.696 3.623 0 2 1.655 3.622 3.696 3.622Z",
    stroke: "#141413"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 9.786a7.78 7.78 0 0 1 2.136 2.409c.534.94.864 1.981.967 3.055m-10.769 0a7.673 7.673 0 0 1 .966-3.055 7.78 7.78 0 0 1 2.135-2.41",
    stroke: "#141413",
    strokeLinecap: "round"
  })));
};

export default SvgUser;